module.exports = __webpack_public_path__ + "img/finance.5633994d.png";